/* import __COLOCATED_TEMPLATE__ from './batched-invoice-breakdown-modal.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { closeModal } from 'sh-www/utils/modal-controls';

const CLASS_NAME = 'SH-c-batched-invoice-breakdown-modal';

class BatchedInvoiceBreakdownModal extends Component {
  @service constants;

  get className() {
    return CLASS_NAME;
  }

  @action
  handleDismiss() {
    closeModal(this);
  }
}

export default BatchedInvoiceBreakdownModal;
